import axios, { API_URL } from './BaseService';

const AUTOMATIONS_URL = `${API_URL}/automations/`;

export async function getAutomations(page) {
    const automationsUrl = `${AUTOMATIONS_URL}?page=${page}`;
    const response = await axios.get(automationsUrl);
    return response.data;//{count, rows}
}

export async function getAutomationsBySymbol(symbol) {
    const automationsUrl = `${AUTOMATIONS_URL}?symbol=${symbol}`;
    const response = await axios.get(automationsUrl);
    return response.data;
}

export async function getSharedAutomations(symbol = '', includePublic = true, page = 1) {
    const automationsUrl = `${AUTOMATIONS_URL}shared?page=${page}&symbol=${symbol}&public=${includePublic}`;
    const response = await axios.get(automationsUrl);
    return response.data;
}

export async function getAllAutomations() {
    const automationsUrl = `${AUTOMATIONS_URL}all`;
    const response = await axios.get(automationsUrl);
    return response.data;
}

export async function getAutomation(id) {
    const response = await axios.get(`${AUTOMATIONS_URL}${id}`);
    return response.data;
}

export async function saveLaunchAutomation(id, newAutomation) {
    let response;
    if (id)
        response = await axios.patch(`${AUTOMATIONS_URL}launch/${id}`, newAutomation);
    else
        response = await axios.post(`${AUTOMATIONS_URL}launch`, newAutomation);
    return response.data;
}

export async function saveAutomation(id, newAutomation) {
    let response;
    if (id)
        response = await axios.patch(`${AUTOMATIONS_URL}${id}`, newAutomation);
    else
        response = await axios.post(AUTOMATIONS_URL, newAutomation);
    return response.data;
}

export async function saveGrid(id, newAutomation, levels, quantity, token) {
    let response;
    if (id)
        response = await axios.patch(`${AUTOMATIONS_URL}${id}?levels=${levels}&quantity=${quantity}`, newAutomation);
    else
        response = await axios.post(`${AUTOMATIONS_URL}?levels=${levels}&quantity=${quantity}`, newAutomation);
    return response.data;
}

export async function deleteAutomation(id) {
    const response = await axios.delete(`${AUTOMATIONS_URL}${id}`);
    return response.data;
}

export async function startAutomation(id) {
    const response = await axios.post(`${AUTOMATIONS_URL}${id}/start`, {});
    return response.data;
}

export async function stopAutomation(id) {
    const response = await axios.post(`${AUTOMATIONS_URL}${id}/stop`, {});
    return response.data;
}

export async function copyAutomation(id) {
    const response = await axios.post(`${AUTOMATIONS_URL}${id}/copy`, {});
    return response.data;
}

export async function doBacktest(newBacktest) {
    delete newBacktest.results;

    newBacktest.startTime = new Date(newBacktest.startTime).getTime();
    newBacktest.endTime = new Date(newBacktest.endTime).getTime();

    // garante que startBase e startQuote sejam números válidos
    newBacktest.startBase = parseFloat(newBacktest.startBase) || 0;
    newBacktest.startQuote = parseFloat(newBacktest.startQuote) || 0;

    const response = await axios.post(`${AUTOMATIONS_URL}backtest`, newBacktest);
    return response.data;
}

export async function getBacktestProgress() {
    const response = await axios.get(`${AUTOMATIONS_URL}backtest/progress`);
    return response.data; // { progress, paused }
}

export async function pauseBacktest() {
    const response = await axios.post(`${AUTOMATIONS_URL}backtest/pause`, {});
    return response.data;
}

export async function resumeBacktest() {
    const response = await axios.post(`${AUTOMATIONS_URL}backtest/resume`, {});
    return response.data;
}

export async function generateAutoGrid(symbol, percentage = 10, levels = 5, priceRange = 5) {
    const response = await axios.post(`${AUTOMATIONS_URL}generate-grid`, {
        symbol,
        percentage,
        levels,
        priceRange
    });
    return response.data;
}